var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPillPsh = function SvgPillPsh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "#FFB4B8",
    rx: 16.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1113",
    d: "M24.966 8.14H8.14v6.643h16.827zM24.966 22.598H8.14v2.263h16.827zM24.966 16.932H8.14v3.409h16.827z"
  })));
};
export { SvgPillPsh as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMzIiBoZWlnaHQ9IjMzIiByeD0iMTYuNSIgZmlsbD0iI0ZGQjRCOCIvPgo8cGF0aCBkPSJNMjQuOTY2NCA4LjEzOTI3SDguMTM5MjZWMTQuNzgyOUgyNC45NjY0VjguMTM5MjdaIiBmaWxsPSIjMEUxMTEzIi8+CjxwYXRoIGQ9Ik0yNC45NjY0IDIyLjU5NzVIOC4xMzkyNlYyNC44NjA2SDI0Ljk2NjRWMjIuNTk3NVoiIGZpbGw9IiMwRTExMTMiLz4KPHBhdGggZD0iTTI0Ljk2NjQgMTYuOTMxOEg4LjEzOTI2VjIwLjM0MDdIMjQuOTY2NFYxNi45MzE4WiIgZmlsbD0iIzBFMTExMyIvPgo8L3N2Zz4K";